import React from 'react'
import {Typography, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import GridBlock from 'components/GridBlock';
import Button from 'components/Button';
import {FieldArray} from 'formik';
import Tr from 'translations/Translations';
import AddIcon from '@material-ui/icons/AddBoxOutlined'
import removeFormikListElement from 'libs/removeFormikListElement';
import getObjectValue from "libs/getObjectValue";

const style = theme => ({
    root: {}
})

function CriteriaListBase({
        classes,
        formikProps,
        id,
        Element,
        onAdd,
        disabled
    }) {

    const handleDelete = index => {
        removeFormikListElement(formikProps, id, index)
    }
    const errorValue = getObjectValue(id, formikProps.errors, null);
    const errorWholeTabValue = Array.isArray(errorValue) ? null : errorValue;
    const editable = getObjectValue('_editable', formikProps.values, false);

    return (
        <div className={classes.root}>
            <GridBlock justify='space-between'>
                <Typography variant='body1' className={classes.title}>
                    {Tr('values')}
                </Typography>
            </GridBlock>
            <FieldArray
                name='id'
                render={arrayHelpers => formikProps.values[id].map(
                    (item, i, arr) => {
                        return (
                            <Element
                                key={i}
                                index={i}
                                formikProps={formikProps}
                                onDelete={() => handleDelete(i)}
                                isLast={arr.length - 1 === i}
                                disabled={disabled}
                            />
                        )
                    }
                )}
            />
			{!!errorWholeTabValue && <Typography
				variant='body1'
				color='error'
			>
				{errorWholeTabValue}
			</Typography>}

            {editable && !disabled &&
            <Button variant='text' onClick={onAdd} Icon={AddIcon}>
                {Tr('specify_value')}
            </Button>
            }
        </div>
    )
}

CriteriaListBase.propTypes = {
    classes: PropTypes.any,
    Element: PropTypes.object,
    onDelete: PropTypes.func,
    onAdd: PropTypes.func,
}

CriteriaListBase.defaultProps = {}

export default withStyles(style)(CriteriaListBase);